"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4414],{

/***/ 44414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 14c.6 0 1-.4 1-1s-.4-1-1-1H13V8h8c.5 0 .9-.3 1-.8.1-.5-.1-.9-.6-1.1l-9-4c-.3-.1-.5-.1-.8 0l-9 4c-.4.2-.7.6-.6 1.1.1.5.5.8 1 .8h8v4H7.5c-.6 0-1 .4-1 1s.4 1 1 1H11v7c0 .6.4 1 1 1s1-.4 1-1v-7h3.5zM12 4.1L16.3 6H7.7L12 4.1zM8 16H4v-3c0-.6-.4-1-1-1s-1 .4-1 1v8c0 .6.4 1 1 1s1-.4 1-1v-3h3v3c0 .6.4 1 1 1s1-.4 1-1v-4c0-.6-.4-1-1-1zm12-3c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1s-1-.4-1-1v-3h-3v3c0 .6-.4 1-1 1s-1-.4-1-1v-4c0-.6.4-1 1-1h4v-3z"
}), "Terrace"));


/***/ })

}]);